module.exports = __webpack_public_path__ + "static/img/2s-design-b4.262db89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/2s-design-b4.jpg
// module id = Xz3Y
// module chunks = 0